// Video action types
export const VIDEO_ACTION_TYPES = {
  SET_MAIN_STREAM: 'SET_MAIN_STREAM',
  SET_ADMIN_STREAM: 'SET_ADMIN_STREAM',
  SET_USER_STREAM: 'SET_USER_STREAM',
  SET_FEEDBACK_STREAM: 'SET_FEEDBACK_STREAM',
  CLEAR_MAIN_STREAM: 'CLEAR_MAIN_STREAM',
  CLEAR_ALL_STREAMS: 'CLEAR_ALL_STREAMS',
  SET_LOADING: 'SET_LOADING',
  SET_USER_CAMERA_ENABLED: 'SET_USER_CAMERA_ENABLED',
  SET_VIDEO_READY: 'SET_VIDEO_READY',
  SET_CAMERA_ERROR: 'SET_CAMERA_ERROR',
  CLEAR_CAMERA_ERROR: 'CLEAR_CAMERA_ERROR',
  SET_CAMERA_CONFLICT: 'SET_CAMERA_CONFLICT',
  CLEAR_CAMERA_CONFLICT: 'CLEAR_CAMERA_CONFLICT',
};

// Camera error types
export const CAMERA_ERROR_TYPES = {
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
  DEVICE_IN_USE: 'DEVICE_IN_USE',
  NOT_READABLE: 'NOT_READABLE',
  OVERCONSTRAINED: 'OVERCONSTRAINED',
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  UNKNOWN: 'UNKNOWN',
};
